import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { defaultProps } from 'recompose';

import CommonTable from '@/components/CommonTable';
import {
  updateLimit,
  updatePage,
  updateSort,
} from '@/features/salesTurnoverDetailsPage/actions';
import {
  getLimit,
  getPage,
  getSort,
} from '@/features/salesTurnoverDetailsPage/selectors';

import ColGroup from './ColGroup';
import FiltersRow from './FiltersRow';
import HeadRow from './HeadRow';
import Row from './Row';

const mapStateToProps = state => ({
  limit: getLimit(state),
  page: getPage(state),
  sort: getSort(state),
});

const mapDispatchToProps = { updateLimit, updatePage, updateSort };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  defaultProps({
    HeadRow,
    Row,
    ColGroup,
    TopRow: FiltersRow,
  }),
)(CommonTable);
